import React from 'react';
import { Container, BHANSALogo, AntEngineLogo } from './RegisterPanel.style';
import RegisterForm from '../registerForm/RegisterForm';

const RegisterPanel = () => (
  <Container>
    <BHANSALogo href="https://www.bhansa.gov.ba/" target="_blank" />
    <RegisterForm />
    <AntEngineLogo href="https://www.antecna.com/" target="_blank" />
  </Container>
  );

export default RegisterPanel; 